// extracted by mini-css-extract-plugin
export default {"DirectFlightLabel":"DirectFlightLabel_DirectFlightLabel__MTJlN"};